module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Regular-52a1405e.woff";